import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../../redux/slices/profileSlice";

const YearsExperienceModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");

  const experienceOptions = [
    { value: "<1", label: "Less than 1 year" },
    { value: "1-2", label: "1 - 2 years" },
    { value: "2-5", label: "2 - 5 years" },
    { value: "5-10", label: "5 - 10 years" },
    { value: "10+", label: "10+ years" },
  ];

  // Load existing value
  useEffect(() => {
    if (!show) return;

    const current =
      store?.profileItem?.data?.nurseProfile?.years_experience;

    if (current) {
      setSelectedOption(current);
    }
  }, [show, store?.profileItem]);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };

  const handleSave = () => {
    if (!selectedOption) {
      setError("Please select your experience");
      return;
    }

    const formData = new FormData();

    formData.append(
      "name",
      store?.profileItem?.data?.name ||
        store?.profileItem?.data?.full_name ||
        ""
    );

    formData.append("years_experience", selectedOption);

    dispatch(updateProfile(formData));
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">
          How many years of nursing experience do you have?
        </h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {experienceOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedOption === option.value}
                    readOnly
                  />

                  <label className="radio-label">
                    {option.label}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedOption}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default YearsExperienceModal;